module.exports = {"title":"Videos","popover":"Here you can upload videos for your guardians to download.","addVideoButton":"Add video +","meta":"Videos"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/videos.json
// module id = e4ji
// module chunks = 1